<template>
  <transition
    v-bind="$attrs"
    v-on="hooks"
    :enterActiveClass="$style['slideXLeftIn']"
    :moveClass="$style['slide-move']"
    :leaveActiveClass="$style['slideXLeftOut']">
    <slot />
  </transition>
</template>

<script>
export default {
  props: {
    styles: {
      type: Object,
      default: () => {
        return {
          animationFillMode: 'both',
          animationDelay: '.4s',
          animationTimingFunction: 'cubic-bezier(.25,.8,.50,1)'
        }
      }
    },
    duration: {
      type: [Number, Object],
      default: 300
    }
  },

  computed: {
    hooks () {
      return {
        beforeEnter: this.beforeEnter,
        afterEnter: this.cleanUpStyles,
        beforeLeave: this.beforeLeave,
        leave: this.leave,
        afterLeave: this.cleanUpStyles,
        ...this.$listeners
      }
    }
  },

  methods: {
    beforeEnter (el) {
      let enterDuration = this.duration.enter ? this.duration.enter : this.duration

      el.style.animationDuration = `${enterDuration / 1000}s`
      el.style.position = 'absolute'
      el.style.zIndex = '1'

      this.setStyles(el)
    },

    cleanUpStyles (el) {
      Object.keys(this.styles).forEach(key => {
        const styleValue = this.styles[key]

        if (styleValue) {
          el.style[key] = ''
        }
      })

      el.style.position = ''
      el.style.zIndex = ''
      el.style.animationDuration = ''
    },

    beforeLeave (el) {
      let leaveDuration = this.duration.leave ? this.duration.leave : this.duration

      el.style.animationDuration = `${leaveDuration / 1000}s`

      this.setStyles(el)
    },

    leave (el) {
      this.setAbsolutePosition(el)
    },

    setStyles (el) {
      this.setTransformOrigin(el)

      Object.keys(this.styles).forEach(key => {
        const styleValue = this.styles[key]

        if (styleValue) {
          el.style[key] = styleValue
        }
      })
    },

    setAbsolutePosition (el) {
      if (this.group) {
        el.style.position = 'absolute'
      }

      return this
    },

    setTransformOrigin (el) {
      if (this.origin) {
        el.style.transformOrigin = this.origin
      }

      return this
    }
  }
}
</script>

<style lang="scss" module>
.slide-move {
  transition: opacity .1s, transform .3s;
}

@keyframes slideXLeftIn {
  from {
    opacity: 0;
    transform: translateX(60px);
  }

  to {
    opacity: 1;
  }
}

.slideXLeftIn {
  animation-name: slideXLeftIn;
}

@keyframes slideXLeftOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translateX(-200px);
  }
}

.slideXLeftOut {
  animation-name: slideXLeftOut;
}
</style>
